import { Button } from "../Button";
import { ResourceChipFetch } from "../Chip";
import { Dialog, useDialog } from "../Dialog";
import { ServerSelector } from "../../common/ServerSelector";
import { ServerGroupSelector } from "../../common/ServerGroupSelector";
import { resourceTypeMatch } from "../../common/AccessControl";
import { StorageApiClientSelector } from "../../common/StorageApiClientSelector";
import { LoadBalancerSelector } from "../../common/LoadBalancerSeletor";
import { Card } from "../Card";

import type { AccessControlTarget, BbTargetKinds } from "../../../api/type";
import type { EditorDirect } from "../../common/Editor";

type SelectedResourceProps = AccessControlTarget & {
    kind: BbTargetKinds;
    value: string;
    onChange: (value: string) => void;
    errorText: null|string;
}

const kindToTitle = {
    'grp': 'Choose Server Group',
    'srv': 'Choose Server',
    'lba': 'Choose Load Balancer',
    'cli': 'Choose API Client',
}

function ResourceSelectorForKind({ dialog, kind, kindEditor, }) {
    if (kind === 'grp') {
        return (
            <Dialog
                title={kindToTitle['grp']}
                dialog={dialog}
                type='selector'
                render={() => <ServerGroupSelector editor={kindEditor} selectSingle={true} autoFocusSearch={true}/>}
            />
        )
    } else if (kind === 'srv') {
        return (
            <Dialog
                title={kindToTitle['srv']}
                dialog={dialog}
                type='selector'
                render={() => <ServerSelector editor={kindEditor} selectSingle={true} autoFocusSearch={true}/>}
            />
        )
    } else if (kind === 'lba') {
        return (
            <Dialog
                title={kindToTitle['lba']}
                dialog={dialog}
                type='selector'
                render={() => <LoadBalancerSelector editor={kindEditor} selectSingle={true} autoFocusSearch={true}/>}
            />
        )
    } else if (kind === 'cli') {
        return (
            <Dialog
                title={kindToTitle['cli']}
                dialog={dialog}
                type='selector'
                render={() => <StorageApiClientSelector editor={kindEditor} selectSingle={true}
                                                        autoFocusSearch={true}/>}
            />
        )
    }
}

export function InlineDialogResourceSelector({ kind, value, onChange, errorText }: SelectedResourceProps) {
    const dialog = useDialog([]);

    const kindEditor: EditorDirect<string, null> = {
        status: 'add',
        value: value !== '' ? [value] : [],
        setValue: (value: ReadonlyArray<string>) => {
            if (value.length) {
                onChange(value[0]);
                dialog.hide();
            } else {
                onChange('');
            }
        },
        errors: null,
        messages: null,
    }

    function onClear() {
        onChange('');
        if (value !== '') {
            dialog.show();
        }
    }

    return (
        <>
            <ResourceSelectorForKind dialog={dialog} kind={kind} kindEditor={kindEditor}/>

            <div className='c-inline-resource-selector'>
                {resourceTypeMatch.test(value)
                    ? <>
                        <Card clear={value !== '' ? onClear : false} hasError={errorText != null}>
                            <ResourceChipFetch id={value}/>
                        </Card>
                        {errorText
                            ? <div className='c-inline-resource-selector__error-text'>{errorText}</div>
                            : null
                        }
                    </>
                    : <Button kind='bare' className='ml-4' onClick={() => dialog.show()} preIcon={value === '' ? 'search' : null}>
                        {kindToTitle[kind] || 'Choose a resource'}
                    </Button>
                }
            </div>
        </>
    )
}